<template>
  <div>
    <HeroSecondary
      v-if="hero"
      :heading="hero.heading"
      :image="hero.image || null"
    />
    <div class="ViewPrograms__container">
      <UnltdRepeatBG class="UnltdRepeatBG"/>
      <UnltdRepeatBG class="UnltdRepeatBG-two"/>
      <ProgramsMethod
        v-if="method"
        v-bind="method"
        class="ViewPrograms__method"
      />
      <ul
        v-if="categories"
        class="ViewPrograms__tiles"
      >
        <li
          v-for="({ name, tile, slug }) in categories"
          :key="slug"
          class="tile"
        >
          <div class="tile-inner">
            <router-link :to="{ name: 'category', params: { category: slug } }">
              <BaseImage
                v-if="tile && tile.image"
                :id="tile.image"
                class="image"
              />
            </router-link>
            <div class="link-wrapper">
              <LinkButton
                :to="{ name: 'category', params: { category: slug } }"
                class="link"
              >See all {{ name }}</LinkButton>
            </div>
          </div>
        </li>
      </ul>
      <ProgramsBadge class="ProgramsBadge"/>
    </div>
  </div>
</template>

<script>
  import Option from '@/api/options';
  import { fetchCategories } from '@/api/programs';

  import LinkButton from './LinkButton';
  import HeroSecondary from './HeroSecondary';
  import ProgramsMethod from './ProgramsMethod';
  import ProgramsBadge from './ProgramsBadge';
  import UnltdRepeatBG from './UnltdRepeatBG';

  export default {
    components: {
      LinkButton,
      HeroSecondary,
      ProgramsMethod,
      ProgramsBadge,
      UnltdRepeatBG,
    },
    data() {
      return {
        hero: undefined,
        method: undefined,
        categories: undefined,
      };
    },
    created() {
      this.$store.commit('setViewName', 'Programs');

      this.fetchOptions();
      this.fetchCategories();
    },
    methods: {
      cleanCategory({
        name,
        slug,
        acf: {
          tile,
        },
      }) {
        return {
          name,
          tile,
          slug,
        };
      },
      async fetchCategories() {
        this.categories = (await fetchCategories()).map(this.cleanCategory);
      },
      async fetchOptions() {
        const {
          acf: {
            hero,
            clean_method: method,
          },
        } = await Option.find('products-settings');

        this.hero = hero;
        this.method = method;
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .tile {
    & + & {
      margin-top: spacing(base-gamma);
    }

    @include breakpoint(phablet) {
      width: calc(100% / 4);
      padding-right: 1px;
      padding-left: 1px;

      & + & {
        margin-top: 0;
      }

      &:nth-child(2) {
        margin-top: spacing(base-epsilon);
      }

      &:nth-child(3) {
        margin-top: spacing(base-epsilon) * 2;
      }

      &:nth-child(4) {
        margin-top: spacing(base-epsilon) * 3;
      }
    }
  }

  .tile-inner {
    position: relative;
    padding-top: percentage(4 / 3);
    overflow: hidden;

    @include breakpoint(phablet) {
      padding-top: percentage(16 / 9);
    }
  }

  .parallax {
    $translate-y: 10%;

    position: absolute;
    top: -$translate-y;
    left: 0;
    width: 100%;
    height: calc(100% + #{$translate-y * 2});
  }

  .image {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .link-wrapper {
    position: absolute;
    color: color(white);
    right: 0;
    left: 0;
    bottom: 0;
    margin-bottom: spacing(base-delta);
    text-align: center;
  }

  .link {
    display: inline-block;
  }

  .ViewPrograms__container {
    position: relative;
    max-width: $max-width;
    margin-right: auto;
    margin-left: auto;

    @include breakpoint(phablet) {
      margin-top: spacing(base-eta);
      margin-bottom: spacing(base-eta);
      padding-right: spacing(base-epsilon);
      padding-left: spacing(base-epsilon);
    }
  }

  .ViewPrograms__method {
    @include breakpoint(tablet) {
      margin-right: spacing(base-delta) / -2;
      margin-left: spacing(base-delta) / -2;
    }
  }

  .ViewPrograms__tiles {
    display: flex;
    flex-direction: column;
    padding: (spacing(base-gamma) / 2) + spacing(base-delta);
    position: relative;
    z-index: 2;

    .ViewPrograms__method + & {
      @include breakpoint(phablet) {
        margin-top: spacing(base-zeta);
      }
    }

    @include breakpoint(phablet) {
      padding: 0;
      flex-direction: row;
    }

    @include breakpoint(tablet) {
      margin-right: spacing(gutter) / -2;
      margin-left: spacing(gutter) / -2;
    }
  }

  .ProgramsBadge {
    display: none;

    @include breakpoint(phablet) {
      position: absolute;
      left: 100px;
      bottom: -150px;
      z-index: 1;
      display: block;
      height: 380px;
      fill: rgba(color(slate), 0.15);
    }
  }

  .UnltdRepeatBG {
    position: absolute;
    z-index: 0;
    top: 0;
    right: 0;
    height: 450px;
    fill: color(lightest-grey);
    transform: translateX(5%);

    @include breakpoint(phablet) {
      height: 600px;
      transform: translateX(50%);
    }
  }

  .UnltdRepeatBG-two {
    position: absolute;
    z-index: 0;
    top: 480px;
    right: 0;
    height: 450px;
    fill: color(lightest-grey);
    transform: translateX(5%);

    @include breakpoint(phablet) {
      top: 630px;
      height: 600px;
      transform: translateX(50%);
    }
  }
</style>
